import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  text-align: left;
  gap: 13px;
`;

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 10px;

  @media (max-width: 768px) {
    padding-right: 34px;
  }
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;

  margin-block-start: 0;
  margin-block-end: 0;
`;

export const Description = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;

  margin-block-start: 0;
  margin-block-end: 0;
`;
